import { HomeTab } from '@/src/components/home/home-tabs/HomeTabs'
import { useTabNavigation } from '@/src/hooks/use-tab-navigation/useTabNavigation'

export const useHubNavigation = () =>
  useTabNavigation<HomeTab>({
    basePath: '/my-hub',
    validTabs: ['diagnosis', 'actions', 'history'],
    defaultTab: 'diagnosis',
  })
